export const SendingAttachmentsDialogName = 'SendingAttachmentsDialogComponent';
